<template>
  <div class="form-group field-input-container">
    <i
      v-if="$attrs.type === 'password'"
      :class="[
        'far fa-eye-slash m-auto show-password',
        {
          'lang-en': isEN,
        },
      ]"
      ref="showPassword"
      @click="showPass"
    >
    </i>
    <input
      ref="input"
      :value="formattedValue"
      :title="label"
      :style="style.input"
      :class="[
        'form-control',
        [inputClass],
        {
          ltr: number,
          fanum: !isEN,
          error: error,
        },
      ]"
      :autocomplete="autocompleteOff ? 'new-password' : null"
      v-on="inputListeners"
      v-bind="$attrs"
    />
    <div
      :class="[
        'placeholder unselectable form-label',
        placeholderClass,
        {
          'fix-label': fixLabel,
          'lang-en': isEN,
        },
      ]"
      @click="fixLabel ? null : $refs.input.focus()"
    >
      {{ label }}
      <i
        v-if="help"
        :id="helpPopoverId"
        class="fa fa-question-circle fa-flip-horizontal"
        style="cursor:pointer"
      ></i>
    </div>
    <div
      v-if="error || serverError"
      :id="$attrs.name + '_error'"
      :class="['error-text d-inline-block mt-2 mb-1', { fanum: !isEN }]"
      v-html="error || serverError"
    ></div>
  </div>
</template>

<script>
import { perToEngDigits } from "~/utils";

export default {
  inheritAttrs: false,
  props: {
    isEN: Boolean,
    value: {
      type: [String, Number],
      required: true,
    },
    number: {
      type: Boolean,
      default: false,
    },
    largeFont: {
      type: Boolean,
      default: false,
    },
    phone: {
      type: Boolean,
      default: false,
    },
    fixLabel: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    help: {
      type: String,
      default: "",
    },
    inputClass: {
      type: String,
      default: "",
    },
    serverError: {
      type: String,
      default: "",
    },
    rules: {
      type: Array,
      default: () => [],
    },
    autocompleteOff: {
      type: Boolean,
      default: false,
    },
    validateOnInput: {
      type: Boolean,
      default: false,
    },
    inputStyle: {
      type: Object,
      default: () => {},
    },
    noTrim: {
      type: Boolean,
      default: false,
    },
  },
  data: (vm) => ({
    placeholderClass: "",
    error: "",
    formattedValue: vm.number ? perToEngDigits(vm.value) : vm.value,
  }),
  created() {
    this.style = {
      input: {
        ...(this.largeFont && {
          paddingTop: "5px",
          paddingBottom: "5px",
          letterSpacing: "2px",
          fontSize: "1.25rem",
        }),
        ...(this.$attrs.type === "password" &&
          !this.isEN && {
            paddingLeft: "37px",
          }),
        ...this.inputStyle,
      },
    };
  },
  computed: {
    inputListeners() {
      return {
        ...this.$listeners,
        focus: () => this.labelHandler("focus"),
        blur: () => this.labelHandler("blur"),
        input: this.inputHandler,
      };
    },
    helpPopoverId() {
      if (this.help) {
        return `help_${Math.floor(Math.random() * 100)}`;
      }
    },
  },
  watch: {
    value(val) {
      if (this.rules.length > 0 && this.validateOnInput) {
        this.validate();
      }
      let temp = val;
      !this.noTrim && (temp = temp.replace(/ /g, ""));
      temp = temp.trim();
      this.number && (temp = perToEngDigits(temp));
      this.formattedValue = temp;
    },
    formattedValue() {
      this.labelHandler("blur");
    },
    label() {
      this.$nextTick(() => {
        this.popoverHandler();
      });
    },
  },
  mounted() {
    this.labelHandler("blur");
    this.$nextTick(() => {
      if (document.querySelector(`#${this.helpPopoverId}`)) {
        new bootstrap.Popover(
          document.querySelector(`#${this.helpPopoverId}`),
          {
            title: this.label,
            content: this.help,
            placement: "top",
            trigger: "hover",
          }
        );
      }
      // $(`#${this.helpPopoverId}`).popover({
      //   title: this.label,
      //   content: this.help,
      //   placement: "top",
      //   trigger: "hover",
      // });
    });
  },
  methods: {
    inputHandler(event, ...other) {
      let temp = event.target.value;
      !this.noTrim && (temp = temp.replace(/ /g, ""));
      temp = temp.trim();
      this.number && (temp = perToEngDigits(temp));
      this.formattedValue = temp;
      this.$emit("input", this.formattedValue, ...other);
    },
    labelHandler(action) {
      if (action === "focus") {
        this.placeholderClass = "focus";
      } else if (action === "blur") {
        this.placeholderClass = this.formattedValue ? "focus" : "";
      }
    },
    showPass() {
      const {
        $refs: { showPassword, input },
      } = this;
      showPassword.classList.toggle("fa-eye-slash");
      showPassword.classList.toggle("fa-eye");
      input.type = input.type === "password" ? "text" : "password";
    },
    replaceValue(value) {
      this.formattedValue = this.number ? perToEngDigits(value) : value;
      this.$emit("input", value);
    },
    resetError() {
      this.error = "";
    },
    validate() {
      if (this.rules.length) {
        this.error = "";
        for (const rule of this.rules) {
          const result = rule(this.value);
          if (result === true) {
            continue;
          }
          this.error = result;
          break;
        }
      }
      return this.error === "";
    },
    focus() {
      this.$refs.input.focus();
    },
    popoverHandler() {
      if (document.querySelector(`#${this.helpPopoverId}`)) {
        const popover = bootstrap.Popover.getOrCreateInstance(
          document.querySelector(`#${this.helpPopoverId}`)
        );
        popover.dispose();
      }
      // $(`#${this.helpPopoverId}`)
      //   .popover("dispose")
      //   .popover({
      //     title: this.label,
      //     content: this.help,
      //     placement: "top",
      //     trigger: "hover",
      //   });
    },
  },
};
</script>

<style scoped lang="scss">
.field-input-container {
  position: relative;
  margin-bottom: 0;

  .placeholder {
    position: absolute;
    top: 13px;
    right: 10px;
    color: #777;
    padding: 0 5px;
    background-color: white;
    transition: all 0.15s;
    border-radius: 3px;

    &.focus {
      top: -10px;
      font-size: 13px;
    }
    &.fix-label {
      top: -10px;
    }
    &.lang-en {
      right: unset;
      left: 10px;
    }
  }
  input:focus ~ .placeholder.focus {
    color: #2476ad;
  }
  input:focus {
    color: #495057;
    background-color: #fff;
    border-color: #2476ad;
    border-width: 2px;
    outline: 0;
    box-shadow: none;
  }
  input ~ .error-icon {
    opacity: 0;
    transition: all 0.15s;
  }
  input.error ~ .error-icon {
    opacity: 1;
  }
  .show-password {
    color: #666;
    cursor: pointer;
    background-color: transparent;
    transition: all 0.25s;
    position: absolute;
    top: 1px;
    left: 6px;
    padding: 15px 10px;
    z-index: 1;
    &.lang-en {
      left: unset;
      right: 6px;
    }
  }
  input {
    padding-top: 13px;
    padding-bottom: 10px;
    height: calc(1.5em + 0.75rem + 14px);
  }
}
</style>
<style>
.popover {
  direction: rtl;
}
</style>
